define.alias("ember-composable-helpers/helpers/has-previous", "settings/helpers/has-previous");